import eventbus from '../eventbus';
import { culture } from '../intl';

class TickerData {
	constructor() {
		this.connections = [];

		const socketBaseUrl = document.body.dataset.socketUrl;
		const productsUrl = `${socketBaseUrl}/QuotesForProducts`;
		const underlyingsUrl = `${socketBaseUrl}/QuotesForUnderlyings`;

		try {
			const socketProducts = new WebSocket(productsUrl);
			const socketUnderlyings = new WebSocket(underlyingsUrl);

			this.connections = [
				{ websocket: socketProducts, type: 'product' },
				{ websocket: socketUnderlyings, type: 'underlying' },
			];
		} catch (e) {
			console.warn('Error while connecting with websocket:', e.message, {
				productsUrl,
				underlyingsUrl,
			});
		}

		this.start();
	}

	start() {
		this.connections.forEach(({ websocket }) => {
			websocket.addEventListener('message', e => TickerData.onMessage(e));
		});

		window.addEventListener('beforeunload', () => this.closeConnections());
	}

	closeConnections() {
		this.connections.forEach(({ websocket }) => websocket.close());

		// https://jira.vicompany.nl/browse/BNPETSSUP-123
		// set references to `null`, otherwise IE11 keeps the reference even after a page reload
		// resulting in more than 6 simultaneously connections, which throws an exception error
		this.connections = null;
	}

	getWebsocket(type) {
		const { websocket = null } = this.connections.find(c => c.type === type) || {};

		return websocket;
	}

	update(type, subscribe = [], unsubscribe = []) {
		const websocket = this.getWebsocket(type);

		if (!websocket) {
			console.warn(`Could not find a websocket connection for type "${type}"`);

			return;
		}

		if (websocket.readyState !== WebSocket.OPEN) {
			const onOpen = () => {
				this.update(type, subscribe, unsubscribe);

				websocket.removeEventListener('open', onOpen);
			};

			websocket.addEventListener('open', onOpen);

			return;
		}

		websocket.send(JSON.stringify({
			culture,
			subscribe,
			unsubscribe,
		}));
	}

	static onMessage({ data = null }) {
		const tick = JSON.parse(data);

		eventbus.emit(`tick:${tick.Isin}`, tick);
	}
}

export default new TickerData();
